import { SummitIcon } from './SummitIcon';

/**
 * author: Austin Andrews
 * id 052D93D8-A1F1-450C-99F3-AEEE07D77CF4
 * name summit
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/summit.svg
 * tags
 */
export const PeakIcon = SummitIcon;
export default PeakIcon